import { Alert, Snackbar } from '@mui/material'
import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { setRequestTextSnackBar } from '../../redux/actions/app'

export const SnackBarError = () => {
  const [openSnackBarError, setOpenSnackBarError] = useState(false)
  const app = useSelector((state) => state.app)
  const dispatch = useDispatch()

  const handleCloseSnackbarError = (event, reason) => {
    if (reason === 'clickaway') {
      return
    }
    setOpenSnackBarError(false)
    dispatch(setRequestTextSnackBar())
  }

  useEffect(() => {
    if (app.error && !openSnackBarError) {
      setOpenSnackBarError(true)
    }
  }, [app.error])

  return (
    <Snackbar
      open={openSnackBarError}
      autoHideDuration={6000}
      onClose={handleCloseSnackbarError}
    >
      <Alert
        onClose={handleCloseSnackbarError}
        severity="error"
        sx={{ width: '100%' }}
      >
        {app.error}
      </Alert>
    </Snackbar>
  )
}

export const SnackBarSuccess = () => {
  const app = useSelector((state) => state.app)
  const [openSnackBarSuccess, setopenSnackBarSuccess] = useState(false)

  const handleCloseSnackbarSuccess = (event, reason) => {
    if (reason === 'clickaway') {
      return
    }
    setopenSnackBarSuccess(false)
  }

  useEffect(() => {
    if (app.success) {
      setopenSnackBarSuccess(true)
    }
  }, [app.success])

  return (
    <Snackbar
      open={openSnackBarSuccess}
      autoHideDuration={6000}
      onClose={handleCloseSnackbarSuccess}
    >
      <Alert
        onClose={handleCloseSnackbarSuccess}
        severity="success"
        sx={{ width: '100%' }}
      >
        {app.success}
      </Alert>
    </Snackbar>
  )
}
